





























import Vue from "vue";
import { Prop, Watch, Component } from "vue-property-decorator";
import * as Localidades from '@lib/Geograficos/Localidades';
import { Localidad } from '@lib/Geograficos/Localidades';

@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue {


    @Prop( { type: String } )
    public value: string;

    @Watch( 'value', { immediate: true } )
    onIndex() {
        this.Selected = this.value;
        this.Busqueda = this.value;
    }

    constructor() {
        super();
    }

    public Items: Localidades.Localidad[] = [];

    public Busqueda: string = '';
    @Watch( 'Busqueda' )
    public async Buscar() {

        if ( this.Busqueda === this.Selected )
            return;

        if ( this.Estado === 'cargando' )
            return;

        this.Estado = 'cargando';

        let e = await Localidades.Localidad.find( { q: this.Busqueda } );
        this.Items = e.Items;

        this.Estado = 'ok';
    }




    public selected: string | null = null;
    public get Selected(): string | Localidad | null {
        return this.selected;
    }
    public set Selected( x: string | Localidad | null ) {
        if ( x instanceof Localidad ) {
            this.selected = x?.Nombre;
            this.$emit( 'localidad', x );
        }
        else
            this.selected = x;

        this.$emit( 'input', this.Selected );
    }

    public async onLostFocus( event: any ) {

    }

    public Estado: 'cargando' | 'ok' | 'error' | 'vacio' | 'iniciado' = 'iniciado';
}
